import axios from 'axios';

import config from 'config';

export default {
    state: {
        login: {
            email: '',
            password: '',
        },
        register: {
            email: '',
            password: '',
            confirm: '',
            first_name: '',
            last_name: '',
            company_url: '',
            company_name: '',
            return_address: {
                addressee: '',
                street_1: '',
                street_2: '',
                city: '',
                province: '',
                postal_code: '',
                country: '',
            },
        },
    },
    actions: {
        async register({state, dispatch}) {
            try {
                let response = await axios.post(`${config.API_URL}customers`, state.register);

                localStorage.setItem('jwt', response.data.access_token);

                commit('updateState', {state: rootState, property: 'jwt', value: response.data.access_token});

                dispatch('getCurrentUser');

                return response;
            } catch (e) {
                throw e;
            }
        },
        async login({rootState, state, dispatch, commit}) {
            try {
                let response = await axios.post(`${config.API_URL}login`, state.login, {'withCredentials': true});

                localStorage.setItem('jwt', response.data.access_token);

                commit('updateState', {state: rootState, property: 'jwt', value: response.data.access_token});

                commit('updateState', {
                    state,
                    property: 'login',
                    value: {
                        email: '',
                        password: '',
                    },
                });

                dispatch('getCurrentUser');

                return response;
            } catch (e) {
                throw e;
            }
        },
    },
    mutations: {},
};
